module.exports = __webpack_public_path__ + "img/messages.a159db23.svg";